"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarImage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledAvatarImage = styled_components_1.default.div `
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  border-radius: 50%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);

  & > img {
    color: transparent;
    width: 100%;
    height: 100%;
    object-fit: cover;
    text-align: center;
    text-indent: 10000px;
    object-fit: contain;
  }

  ${(props) => (props.size === 'sm' || !props.size) &&
    `
    width: 40px;
    height: 40px;
    & > img{
      padding: 2px;
    }
    `}

  ${(props) => props.size === 'md' &&
    `
    width: 64px;
    height: 64px; 
    & > img{
      padding: 5px;
    }
    `}

  ${(props) => props.size === 'lg' &&
    `
    width: 128px ;
    height: 128px; 
    & > img{
      padding: 10px;
    }
    `}
`;
const AvatarImage = ({ src, alt, size }) => (react_1.default.createElement(StyledAvatarImage, { size: size, "data-testid": "AvatarImage" },
    react_1.default.createElement("img", { src: src, alt: alt })));
exports.AvatarImage = AvatarImage;
exports.default = exports.AvatarImage;
